import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { noticeMemory } from "../../Objects/Memory/Memory"
import { NoticeEntity } from "../../Objects/Notice/NoticeEntity"
import { GetRequest } from "../../services/ApiClientService"
import { useTranslation } from "react-i18next"

export const useGetNotice = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetNotice = async (onSuccess: any, database: string = API_ROUTES.NOTICE.GET_ALL) => {
    enableLoad()

    try {
      const response = await GetRequest<NoticeEntity[]>(database)

      if (response.success) {
        const temp = response.data?.map((item) => new NoticeEntity(item)) ?? []

        noticeMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleGetNotice }
}
